// removed by extract-text-webpack-plugin
module.exports = {"page":"_1ewQd","previous":"C9lRN","first":"_2YNcq","next":"_249Tx","last":"_3ygNh","active":"_1GhzZ","large":"_3VJ3c","arrow":"_2qECG","inner":"_2BWQO"};


//////////////////
// WEBPACK FOOTER
// ./app/components/pagination/pagination.scss
// module id = 1309
// module chunks = 0